import React from "react";
import styled, { css } from "styled-components";
import {
  airplay_video_src,
  book_src,
  hamburger_center_justify_src,
  laptop_macbook_src,
  library_src,
  logo_white_src,
  mic_src,
  search_icon_src,
} from "../images/index";
import {
  narrowScreenMediaQuery,
  off_black,
  orangish,
  white,
} from "../constants/styles";
import Notification, { NotifButton } from "./Notification";
import UserProfileMenu from "./UserProfileMenu";
import { LandingSearchContext } from "../providers/ProvideLandingSearch";

const NarrowSidebar = () => {
  const { toggleSearchBox } = React.use(LandingSearchContext);
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const toggleSidebar = React.useCallback(() => {
    if (sidebarOpen) {
      setSidebarOpen(false);
    } else {
      setSidebarOpen(true);
    }
  }, [sidebarOpen]);
  const handleEscapeClick = React.useCallback(
    (evt) => {
      if (evt.key === "Escape") {
        setSidebarOpen(false);
      }
    },
    [setSidebarOpen],
  );
  React.useEffect(() => {
    if (sidebarOpen) {
      document.addEventListener("keydown", handleEscapeClick);
      return () => {
        document.removeEventListener("keydown", handleEscapeClick);
      };
    } else {
      document.removeEventListener("keydown", handleEscapeClick);
    }
  }, [sidebarOpen, handleEscapeClick]);

  return (
    <React.Fragment>
      <NotifButton $noArrow $shownWhenNarrow onClick={toggleSidebar}>
        <img src={hamburger_center_justify_src} alt="menu icon" />
      </NotifButton>
      {sidebarOpen && (
        <NarrowSidebarSection>
          <NarrowSidebarOverlay
            onClick={() => {
              setSidebarOpen(false);
            }}
          />
          <NarrowSidebarContainer>
            <SidebarLogo>
              <a href="/">
                <img src={logo_white_src} alt="logo taxsam" />
              </a>
            </SidebarLogo>
            <SidebarMenuSeparator />

            <SidebarSearchButtonContainer>
              <SearchButton onClick={toggleSearchBox}>
                <SearchIcon src={search_icon_src} />
                <span>Cari</span>
              </SearchButton>
            </SidebarSearchButtonContainer>

            <SidebarMenuSeparator />
            <SidebarMenuTitle>LEARNING TAXSAM.CO</SidebarMenuTitle>
            <SidebarMenuSeparator />
            <SidebarSecondaryMenuContainer>
              <MenuWithIconLink href="/courses">
                <IconInLeftText src={airplay_video_src} />
                Video Pembelajaran
              </MenuWithIconLink>
              <MenuWithIconLink href="/talks">
                <IconInLeftText src={mic_src} />
                Podcast TaxsamTalks
              </MenuWithIconLink>
              <MenuWithIconLink
                href="https://taxbase.taxsam.co/library/workbook"
                target="_blank"
              >
                <IconInLeftText src={library_src} />
                Perpustakaan
              </MenuWithIconLink>
            </SidebarSecondaryMenuContainer>
            <SidebarMenuSeparator />
            <SidebarMenuTitle>TAXSAM.CO SERVICES</SidebarMenuTitle>
            <SidebarMenuSeparator />
            <SidebarSecondaryMenuContainer>
              <MenuWithIconLink
                href="https://taxbase.taxsam.co/library/workbook"
                target="_blank"
              >
                <IconInLeftText src={book_src} />
                Database Perpajakan
              </MenuWithIconLink>
              <MenuWithIconLink
                href="https://taxbase.taxsam.co/library/workbook"
                target="_blank"
              >
                <IconInLeftText src={laptop_macbook_src} />
                Sistem Informasi Akuntansi
              </MenuWithIconLink>
            </SidebarSecondaryMenuContainer>
          </NarrowSidebarContainer>
        </NarrowSidebarSection>
      )}
    </React.Fragment>
  );
};

const UnnamedComponent = (props) => {
  const $transparent = !!props.$transparent;
  const { toggleSearchBox, searchBox } = React.use(LandingSearchContext);

  return (
    <React.Fragment>
      {searchBox}
      <StickyHeader>
        <HeaderSection $transparent={$transparent}>
          <HeaderFlex>
            <HeaderLeftPart>
              <HeaderLogoDiv>
                <a href="/">
                  <HeaderIcon src={logo_white_src} />
                </a>
              </HeaderLogoDiv>
              <HeaderLeftPartMenuAfterLogo>
                <MenuLink $active href="#">
                  TLC
                </MenuLink>
                <MenuLink href="https://taxbase.taxsam.co" target="_blank">
                  Taxbase
                </MenuLink>
                <MenuLink href="#">Sistem Informasi Akuntansi</MenuLink>
                <MenuLink href="/coming_soon?locale=id">
                  Case Management System
                </MenuLink>
              </HeaderLeftPartMenuAfterLogo>
            </HeaderLeftPart>
            <HeaderRightPart>
              <SearchButton onClick={toggleSearchBox}>
                <SearchIcon src={search_icon_src} />
                <span>Cari</span>
              </SearchButton>
              <Notification />
              <UserProfileMenu />
              <NarrowSidebar />
            </HeaderRightPart>
          </HeaderFlex>
        </HeaderSection>
        <HeaderSection
          {...($transparent && {
            $transparent: true,
          })}
        >
          <SecondaryHeaderFlex>
            <MenuLink href="#">Sertifikasi</MenuLink>
            <MenuLink href="#">Video Pembelajaran</MenuLink>
            <MenuLink href="#">Podcast TaxsamTalks</MenuLink>
            <MenuLink href="#">Perpustakaan</MenuLink>
          </SecondaryHeaderFlex>
        </HeaderSection>
      </StickyHeader>
    </React.Fragment>
  );
};
export default UnnamedComponent;

export const StickyHeader = styled.div`
  left: 0;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 5;
`;

const HeaderSection = styled.div`
  background-color: ${off_black};
  border-bottom: 1px solid #3f3c3c;

  ${(props) =>
    props.$transparent &&
    css`
      background-color: unset;
      position: relative;

      &:before {
        content: " ";
        backdrop-filter: blur(6px);
        background-color: #121212a1;
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: -1;
      }
    `};
`;

const HeaderFlex = styled.div`
  align-items: center;
  border-color: #353333;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-between;
  margin-left: auto;
  margin-right: auto;
  max-width: calc(1170px - 20px);
  padding: 0.75rem 10px;
`;

const SecondaryHeaderFlex = styled(HeaderFlex)`
  gap: 5px;
  justify-content: start;

  @media ${narrowScreenMediaQuery} {
    display: none;
  }
`;

const SearchButton = styled.button`
  align-items: center;
  background-color: #2f2f2f;
  border-radius: 7px;
  color: ${white};
  cursor: pointer;
  display: flex;
  line-height: 1.5rem;
  max-height: 38px;
  outline: none;
  padding: 5px 25px 5px 35px;
  position: relative;

  display: none; // WIP TODO
`;

const SearchIcon = styled.img`
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
`;

const HeaderPart = styled.div`
  align-items: center;
  display: flex;
  gap: 5px;
`;

const HeaderLeftPart = styled(HeaderPart)`
  flex: 3 1 0;
`;

const HeaderRightPart = styled(HeaderPart)`
  flex: 1 1 0;
  justify-content: end;

  @media ${narrowScreenMediaQuery} {
    & > ${SearchButton} {
      display: none;
    }
  }
`;

const HeaderLogoDiv = styled.div`
  max-width: 154px;
`;

const HeaderLeftPartMenuAfterLogo = styled.div`
  align-items: center;
  border-left: 1px solid ${white};
  display: flex;
  gap: 5px;

  @media ${narrowScreenMediaQuery} {
    display: none;
  }
`;

const MenuLink = styled.a`
  color: ${white};
  font-size: 16px;
  text-decoration: none;
  padding: 5px;

  &:first-child {
    padding-left: 10px;
  }

  &:hover {
    color: ${orangish};
  }

  ${(props) =>
    props.$active &&
    css`
      color: ${orangish};
    `};
`;

const MenuWithIconLink = styled(MenuLink)`
  align-items: center;
  display: flex;
  gap: 10px;
`;

const HeaderIcon = styled.img`
  width: 100%;
`;

const NarrowSidebarSection = styled.div`
  display: none;

  @media ${narrowScreenMediaQuery} {
    display: block;
  }
`;

const NarrowSidebarOverlay = styled.div`
  background-color: #00000078;
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
`;

const NarrowSidebarContainer = styled.div`
  --narrow-sidebar-width: 270px;
  background-color: #242424;
  color: ${white};
  height: calc(100vh - 40px);
  left: calc(var(--narrow-sidebar-width) * -1);
  padding: 20px 0;
  position: fixed;
  top: 0;
  transform: translateX(var(--narrow-sidebar-width));
  transition: transform 0.2s;
  width: var(--narrow-sidebar-width);
`;

const SidebarLogo = styled.div`
  margin: 0 20px;

  > a {
    display: inline-block;

    & > img {
      max-width: 150px;
    }
  }
`;

const SidebarMenuSeparator = styled.div`
  background-color: #353333;
  height: 1px;
  margin: 10px 0;
`;

const SidebarMenuTitle = styled.h4`
  margin-left: 20px;
  margin-right: 20px;
`;

const SidebarSecondaryMenuContainer = styled.div`
  margin-left: 30px;
  margin-right: 20px;

  & > ${MenuLink} {
    padding-left: 0;

    &:not(:first-child) {
      margin-top: 5px;
    }
  }
`;

const IconInLeftText = styled.img`
  display: inline-block;
`;

const SidebarSearchButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;
